/**
 * The live voice translator's pages (SEO_BRIEF_10 section 3, tools/live_translator.html):
 * /voice-translator, /live-translator, /conversation-translator and the ten translated pages of
 * the first. The translator itself is lib/live-translator/mount.ts; this reads the page's config
 * block (the mode that opens first, the languages it starts with) and mounts it.
 */

import { qs } from '../lib/dom.ts';
import { type LiveTranslatorConfig, mountLiveTranslator } from '../lib/live-translator/mount.ts';

/** The template's config block, or an empty one when it is missing or unreadable. */
function readConfig(): LiveTranslatorConfig {
  const block = qs<HTMLScriptElement>('script[data-tool-config]');
  try {
    const parsed = JSON.parse(block?.textContent ?? 'null') as unknown;
    return typeof parsed === 'object' && parsed !== null ? (parsed as LiveTranslatorConfig) : {};
  } catch {
    return {};
  }
}

export function mountLiveTranslatePage(): void {
  const root = qs<HTMLElement>('[data-live-translator]');
  if (!root) return;
  mountLiveTranslator(root, {
    config: readConfig(),
    region: document.getElementById('banner-region'),
  });
}
